import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom";
import { Badge, Nav } from 'react-bootstrap'
import './_navbars.scss';

import {
    primeNotifications,
    subscribeToNotifications,
    getUnseenCount
} from '../../../utils/notificationsStore';

/**
 * The notification bell, mounted by all 19 navbars and therefore present on
 * essentially every screen.
 *
 * It used to carry its own `graphql(FETCH_STUDENTNOTIFICATIONS)` HOC with
 * `fetchPolicy: "cache-and-network"`. Because react-router remounts the navbar
 * on every route change, that fired a getStudentNotificatons request on every
 * navigation — for a number on a badge. The query now lives in
 * utils/notificationsStore, which fetches once per session; this component only
 * reads the count and re-renders when it changes.
 *
 * `primeNotifications()` is still called on mount, and is a no-op once the list
 * has been loaded. It is what makes the bell work after a hard refresh, when the
 * login-time prime is long gone.
 */
class Navbars extends Component {
    constructor(props) {
        super(props)
        this.state = {
            unseen: getUnseenCount()
        }
    }

    componentDidMount() {
        this.unsubscribe = subscribeToNotifications(() => {
            this.setState({ unseen: getUnseenCount() });
        });
        primeNotifications();
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    }

    render() {
        const { unseen } = this.state;

        // Rendered unconditionally, badge or no badge. The old version returned
        // null while its query was in flight, so the bell popped into the navbar
        // a moment after every page painted.
        return (
            <Nav.Item>
                <Link className="student-notification text-decoration-none nav-link" to="/student/notifications">
                    <span className="position-relative">
                        <i className="fal fa-bell" />
                        {unseen > 0 ? (<Badge className="position-absolute rounded-circle text-white" style={{ top: -14, right: -10, backgroundColor: '#f81201' }}>{unseen}</Badge>) : ("")}
                    </span>
                </Link>
            </Nav.Item>
        )
    }
}

export default withRouter(Navbars);
